<template>
  <div>
    <el-row>
      <el-form class="searchForm" ref="form" :model="findData" label-width="90px" style="margin-top: 20px">
        <el-col :md="10" :lg="10" :xl="8">
          <el-form-item label="申请时间">
            <el-date-picker style="width: 100%" type="daterange" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期" v-model="findData.timeRange" format="yyyy年MM月dd日" value-format="yyyy-MM-dd H:m:s"></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :md="10" :lg="10" :xl="8">
          <el-form-item label="稿件标题">
            <el-input placeholder="模糊检索" v-model="findData.title"></el-input>
          </el-form-item>
        </el-col>

        <el-col :md="4" :lg="4" :xl="4">
          <div style="margin-left: 10px">
            <el-button type="primary" @click="loadData">搜索</el-button>
          </div>
        </el-col>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" style="width: 100%" stripe>
          <el-table-column type="index" width="40" align="center"> </el-table-column>

          <el-table-column prop="createTime" align="center" label="申请时间" width="120">
            <template slot-scope="scope">
              {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
            </template>
          </el-table-column>

          <el-table-column prop="title" label="文章"></el-table-column>
          <el-table-column prop="payAmount" label="原支付金额"></el-table-column>
          <el-table-column prop="deductAmount" label="扣款金额（查重检测费）"></el-table-column>
          <el-table-column prop="refundAmount" label="申请退款金额"></el-table-column>
          <el-table-column prop="status" label="处理状态">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.status == 1">待处理</el-tag>
              <el-tag type="success" v-else-if="scope.row.status == 2">已同意</el-tag>
              <el-tag type="success" v-else-if="scope.row.status == 3">拒绝退款</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="statusResult" label="退款状态">
            <template slot-scope="scope">
              <el-tag type="success" v-if="scope.row.statusResult == 1">退款成功</el-tag>
              <el-tag type="danger" v-else-if="scope.row.statusResult == 2">退款失败</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="resulTime" label="退款时间">
            <template slot-scope="scope">
              {{ scope.row.auditTime | datefmt2("YYYY-MM-DD HH:mm") }}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <el-row style="margin-top: 20px">
      <el-pagination background layout="prev, pager, next" :page-size="pageSize" :total="total" @current-change="pageChange" @prev-click="pagePrev" @next-click="pageNext" style="float: right"> </el-pagination>
    </el-row>
  </div>
</template>

<script>
import refundApi from "@/api/refund"

export default {
  components: {},
  data() {
    return {
      curPage: 1,
      tableData: [],
      total: 0,
      pageSize: 10,

      findData: {
        timeRange: "",
        author: "",
        title: "",
        status: 2,
        statusResult: 1,
      },
    }
  },
  mounted() {
    this.loadData()
  },

  methods: {
    //加载数据
    loadData() {
      refundApi.getList(this.curPage, this.pageSize, this.findData).then((res) => {
        this.total = res.total
        this.tableData = res.rows
      })
    },

    pageChange(current) {
      this.curPage = current
      this.loadData()
    },
    pagePrev(current) {
      this.curPage = current
    },
    pageNext(current) {
      this.curPage = current
    },
  },
}
</script>

<style lang="scss" scoped></style>
